import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { TDocumentDefinitions } from "pdfmake/interfaces";
import { QRCodeSVG } from "qrcode.react";
import ReactDOMServer from "react-dom/server";
import { Content } from "pdfmake/interfaces";


(pdfMake as any).vfs = pdfFonts?.pdfMake?.vfs;

function getBase64Image(img: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(img);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const DesalfandegamentoDeclaracao = async (dados: any) => {

  const today = new Date();
  const dia = today.getDate();
  const mes = today.toLocaleString("pt-BR", { month: "long" });
  const ano = today.getFullYear();

  const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) =>
    res.blob()
  );
  const imageBase64 = (await getBase64Image(imageBlob)) as string;
  const imageConvert = await fetch("/img/logo/bg_fundo.png").then((res) =>
    res.blob()
  );
  const imageArmed = (await getBase64Image(imageConvert)) as string;

  const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
    <QRCodeSVG
      value={`https://armed.gov.ao/verifica-documento/certificado/${dados?.declaracao?._id}`}
      type="svg"
    />
  );

  const getBlocoInspecao = (): Content[] => {
    const pontoEntrada = dados?.declaracao?.pontoEntrada ?? "";

    // =========================
    // PORTO
    // =========================
    if (pontoEntrada.startsWith("Porto")) {
      return [
        {
          text: [
            "=== No entanto, observa-se que a inspecção da mercadoria será efectuada no ",
            {
              text: `Porto de Luanda [ ${pontoEntrada === "Porto de Luanda" ? "X" : ""} ];`,
            },
            {
              text: ` Lobito [ ${pontoEntrada === "Porto de Lobito" ? "X" : ""} ]`,
            },
            {
              text: ` Moçâmedes [ ${pontoEntrada === "Porto de Moçâmedes" ? "X" : ""} ]`,
            },
            {
              text: ` Cabinda [ ${pontoEntrada === "Porto de Cabinda" ? "X" : ""} ]`,
            },
            {
              text: ` Armazém do Importador** [ ${pontoEntrada === "Armazém do Importador" ? "X" : ""} ]`,
              bold: true,
            },
          ],
          style: "body",
          margin: [0, 5, 0, 5],
        },
      ];
    }

    // =========================
    // CORREIOS
    // =========================
    if (
      pontoEntrada.startsWith("Correio") ||
      pontoEntrada.startsWith("Correios")
    ) {
      return [
        {
          text: [
            "=== No entanto, observa-se que a inspecção da mercadoria será efectuada no Correio de: ",
            {
              text: pontoEntrada,
              bold: true,
            },
            ", outro local: (      ) -------------------------------------------------------------------------------------------------- ",
          ],
          style: "body",
          bold: true,
          margin: [0, 5, 0, 5],
        },
      ];
    }

    // =========================
    // AEROPORTO
    // =========================
    if (pontoEntrada.startsWith("Aeroporto")) {
      return [
        {
          text: [
            "=== No entanto, observa-se que a inspecção da mercadoria será efectuada no ",
            {
              text: `Terminal de Cargas do Aeroporto Internacional: António Agostinho Neto [ ${pontoEntrada === "Aeroporto Dr. Antônio Agostinho Neto" ? "X" : ""} ];`,
              bold: true,
            },
            {
              text: ` 4 de Fevereiro [ ${pontoEntrada === "Aeroporto internacional 4 de Fevereiro" ? "X" : ""} ]`,
              bold: true,
            },
            {
              text: ` Mucaca [ ${pontoEntrada === "Mucaca" ? "X" : ""} ]`,
              bold: true,
            },
            {
              text: ` Paulo Teixeira Jorge [ ${pontoEntrada === "Paulo Teixeira Jorge" ? "X" : ""} ]`,
              bold: true,
            },
          ],
          style: "body",
          bold: true,
          margin: [0, 5, 0, 5],
        },
      ];
    }

    // =========================
    // POSTO FRONTEIRIÇO
    // =========================
    if (pontoEntrada.startsWith("Posto Fronteiriço")) {
      return [
        {
          text: [
            "=== No entanto, observa-se que a inspecção da mercadoria será efectuada no(a) ",
            {
              text: `Posto Fronteiriço de: Noqui [ ${pontoEntrada === " Posto Fronteiriço de Noqui" ? "X" : ""} ];`,
              bold: true,
            },
            {
              text: ` Santa Clara [ ${pontoEntrada === "Posto Fronteiriço da Santa Clara" ? "X" : ""} ]`,
              bold: true,
            },
            {
              text: ` Luvo [ ${pontoEntrada === "Posto Fronteiriço do Luvo" ? "X" : ""} ]`,
              bold: true,
            },
            {
              text: ` Ponta Negra [ ${pontoEntrada === "Posto Fronteiriço de Ponta Negra" ? "X" : ""} ]`,
              bold: true,
            },
            {
              text: ` Massabi [ ${pontoEntrada === "Posto Fronteiriço de Massabi" ? "X" : ""} ]`,
              bold: true,
            },
          ],
          style: "body",
          bold: true,
          margin: [0, 5, 0, 5],
        },
      ];
    }

    // Nenhum tipo encontrado
    return [];
  };

  const numeroCompleto = dados?.declaracao?.numeroDeclaracao || "";
  const [numeroDeclaracao, anoDeclarao] = numeroCompleto.split("/");

  const docDefinition: TDocumentDefinitions = {
    pageSize: "A4",
    pageMargins: [45, 10, 45, 100],

    content: [
      {
        columns: [
          {
            //width: "30%",
            stack: [
              {
                svg: qrCodeSVG,
                width: 55,
                height: 55,
                margin: [0, 0, 0, 0],
              },
            ],
            alignment: "left",
            style: "header",
          },
          {
            image: imageBase64 as string,
            width: 60,
            height: 65,
            alignment: "center",
          },
          {
            text: "",
            width: "43%",
          },

        ],
        margin: [0, 40, 0, 5],
      },

      {
        stack: [
          { text: "REPÚBLICA DE ANGOLA", style: "header" },
          {
            columns: [
              { width: "*", text: "" },
              {
                width: 95,
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 0,
                    x2: 95,
                    y2: 0,
                    lineWidth: 1.8,
                    lineColor: "#FFBA00"
                  }
                ]
              },
              { width: "*", text: "" }
            ],
            columnGap: 0,
            margin: [0, 2, 0, 0]
          },
          { text: "Ministério da Saúde", style: "subheader", margin: [0, -5, 0, 0] },
        ]
      },

      {
        text: "Agência Reguladora de Medicamentos e Tecnologias de Saúde",
        style: "subheader2",
      },

      {
        text: [
          `DECLARAÇÃO DE DESALFANDEGAMENTO`,
        ],
        style: "declaracaoText",
        margin: [0, 30, 0, 0],
      },
      {
        text: [
          `N.º`,
          {
            text: `${numeroDeclaracao}`,
            bold: true,
          },
          `/ARMED/${anoDeclarao}`,
        ],
        style: "declaracaoText",
        margin: [0, 0, 0, 10],
      },
      // Texto da declaração
      {
        text: [
          `=== Para devidos efeitos, declara-se que, no livro 001/DLIF/ARMED/2026 da ARMED, nos termos da Lei n° 15/03, de 22 de Julho, Decretos Presidenciais n°s 136/21, de 1 de Junho, 180/10, de 18 de Agosto e 191/10, de 1 de Setembro, conjugados com a Resolução n° 32/08, de 1 de Setembro, consta registada a entidade `,
          { text: `${dados?.importador?.nome}`, bold: true },
          ` sob autorização de exercício farmacêutico n° `,
          { text: `(Não aplicável)`, bold: true },
        ],
        style: "body",
        margin: [0, 10, 0, 5],
      },

      {
        text: [
          `=== Outrossim, declara-se não haver impedimento para que a mesma possa desalfandegar os medicamnetos e/ou tecnologias de saúde constante da(s) facturas(s) nº `,
          { text: `${dados?.numFaturaPro}`, bold: true },
          ` carta de porte nº `,
          { text: `${dados?.declaracao?.numeroPorte}`, bold: true },
          `, proveniente de `,
          { text: `${dados?.paisOrigem}`, bold: true },
          `, e de origem `,
          { text: `${dados?.paisOrigem}`, bold: true },
          { text: `, e que destina a: `, bold: true },
          { text: ` comercialização [ ${dados?.declaracao?.destino === 'Comercialização' ? 'X' : ''} ] doação [ ${dados?.declaracao?.destino === 'Doação' ? 'X' : ''} ]`, bold: true },
        ],
        style: "body",
        margin: [0, 10, 0, 5],
      },
      ...getBlocoInspecao(),

      {
        text: [
          { text: `=== Atenção: `, bold: true },
          `Contém substâncias controladas termolábeis: 2ºC a 8ºC [ ${dados?.declaracao?.termolabeis2Ca8C ? 'X' : ''} ] até 15ºC [ ${dados?.declaracao?.ate15C ? 'X' : ''} ].`,
        ],
        style: "body",
        margin: [0, 5, 0, 5],
      },
      {
        text: [
          `=== E por se verdade e me ter sido solicitada passou-se a presente Declaração, assinada e autenticada com o carimbo em uso nesta Agência Reguladora, para que não lhe seja imposto impedimentos no processo de desalfandegamento. --------------------------------------------------------------------------------------------------------------- `,
        ],
        style: "body",
        margin: [0, 5, 0, 5],
      },
      {
        text: [
          `=== A presente Declaração não isenta eventuais penalizações caso se verifiquem irregularidades no acto da inspecção. --------------------------------------------------------------------------------------------------------------------------------------`,
        ],
        style: "body",
        margin: [0, 5, 0, 5],
      },
      {
        text: [
          `======================== Cópia para Administração Geral Tributária =======================`,
        ],
        style: "body",
        alignment: "center",
        margin: [0, 14, 0, 5],
        bold: true,
        color: "#A02B93",
      },
      {
        text: [
          `Válida por 30 dias`,
        ],
        style: "body",
        alignment: "center",
        margin: [0, 5, 0, 5],
        bold: true,
        color: "#A02B93",
      },
      // Assinatura
      {
        text: [
          `LUANDA, AOS `,
          { text: `${dia}`, bold: true },
          ` DE `,
          { text: `${mes.toUpperCase()}`, bold: true },
          ` DE `,
          { text: `${ano}`, bold: true },
          `.`,
        ],
        alignment: "left",
        margin: [0, 10, 0, 5],
        style: "header",
      },

      //Futuramente Automatizar o nome e a assinatura do Director Geral da ARMED
      {
        text: "O DIRECTOR GERAL",
        alignment: "center",
        style: "signature",
        margin: [0, 15, 0, 10],
      },
      {
        text: "DR. JOSÉ SOLINO JOEL",
        alignment: "center",
        style: "signature",
      },
    ],

    background: function (currentPage, pageSize) {
      return {
        image: imageArmed,
        width: pageSize.width,
        height: pageSize.height,
        absolutePosition: {
          x: 0,
          y: 0,
        },
        opacity: 1,
      };
    },

    /** ESTILOS DE DOCUMENTO **/
    styles: {
      header: {
        fontSize: 10,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
      },
      declaracaoText: {
        fontSize: 12,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
      },
      subheader: {
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
      },
      subheader2: {
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
        color: "#919191",
      },
      declaration: {
        fontSize: 12,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
        decoration: "underline",
      },
      body: {
        fontSize: 11,
        alignment: "justify",
        margin: [0, 0, 0, 10],
        lineHeight: 1.3,
      },
      signature: {
        fontSize: 11,
        bold: true,
        margin: [0, 10, 0, 0],
      },
    },
    defaultStyle: {
      font: "Roboto",
    },
  };

  pdfMake.createPdf(docDefinition).open();
};

export { DesalfandegamentoDeclaracao };
